var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('svg',{class:['icon' + _vm.fontSize, _vm.target],attrs:{"aria-hidden":"true","data-item":_vm.dataAttr},on:{"mouseover":_vm.mouseover,"mouseout":_vm.mouseout,"mousedown":_vm.mousedown,"mouseup":_vm.mouseup,"click":_vm.click}},[_c('use',{attrs:{"data-item":_vm.dataAttr,"xlink:href":_vm.setIcon}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }